exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".no-habilitado[data-v-4990903d]{position:fixed;z-index:99;top:0;left:0;width:100%;height:100%;background-image:url(/public/images/site/stop-background.svg);background-repeat:repeat-x;background-size:1000px;display:flex;justify-content:center;align-items:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4990903d","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/Error.vue
// module id = 519
// module chunks = 0